/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useEffect, useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { getVoicemailAudio } from "../../services/VoicemailAudioService";
import "./style.css";

const VoicemailAudio = ({ audioFileKey }) => {
	const [audioFileSignedLink, setAudioFileSignedLink] = useState("");

	useEffect(() => {
		const fetchAudioLink = async () => {
			try {
				if (audioFileKey) {
					const signedLink = await getVoicemailAudio(audioFileKey);
					setAudioFileSignedLink(signedLink);
				}
			} catch (error) {
				setAudioFileSignedLink("");
			}
		};
		fetchAudioLink();
	}, [audioFileKey]);

	return (
		<AudioPlayer
			showDownloadProgress
			className="player"
			src={audioFileSignedLink}
			showJumpControls={false}
			layout="horizontal-reverse"
			customControlsSection={["MAIN_CONTROLS", "VOLUME_CONTROLS"]}
			autoPlayAfterSrcChange={false}
		/>
	);
};

export default VoicemailAudio;
